import { Injectable } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult } from "@devwareapps/devware-cap";
import { Observable } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentLessonSessonGridQueryEntity, QuizEntity, StudentModuleLessonActivityQueryEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { QuizResultsModalComponent } from "../components/quiz-results-modal/quiz-results-modal.component";
import { QuizResultModalConfig } from "../models/quiz-result-modal-config.model";
import { QuizTestModalComponent } from "../components/quiz-test-modal/quiz-test-modal.component";
import { QuizTestModalConfig } from "../models/quiz-test-modal-config.model";

@DwAction({
    keyName: 'show-quiz-test-modal-action',
    display: 'Show Quiz Test Modal',
    actionType: DwActionType.formAction,
    parentItemName: [AppMetaDataItemNames.Quiz],
    isGlobal: true,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Quiz Test Run',
        iconClass: 'fa fa-question-circle',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Test Quiz'
    }
})
@Injectable()
export class ShowQuizTestModalActionService implements DwActionHandler {
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService
    ) { }


    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        return this.showModal(actionState);
    }

    private showModal(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        let modalConfig = new DwModalConfig<QuizTestModalConfig>();

        modalConfig.buttons = []; // [DwModalButtonStandardConfigs.instance.closeButton]
        modalConfig.allowFullScreen = false;

        modalConfig.component = QuizTestModalComponent;

        modalConfig.title = 'Quiz Test Run';
        modalConfig.data = this.getModalConfig(actionState.data);

        return this.dwModalService.showModal(modalConfig)
            .pipe(map(modalResult => {
                const result = new DwGridActionResult();

                if (modalResult.cancelled) {
                    result.refreshData = false;
                    result.cancelled = true;

                    return result;
                }

                result.refreshData = true;

                return result;
            }));
    }

    private getModalConfig(data?: QuizEntity): QuizTestModalConfig {
        return {
            quizId: data.QuizId,
        };
    }

}